import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import Slider from 'react-slick';
import { classNamesConfig } from '../../../features/classnames';
import { ResponsivePicture } from '../../Image';
const PrevArrow = (props)=>{
    var _props_className;
    const extraClassNames = classNamesConfig().caroussel.clickableSecondary;
    return /*#__PURE__*/ _jsx("button", {
        className: `carousel__arrow carousel__arrow--prev button button--secondary button--icon ${extraClassNames} ${((_props_className = props.className) === null || _props_className === void 0 ? void 0 : _props_className.includes('slick-disabled')) ? 'carousel__arrow--disabled' : ''}`,
        onClick: props.onClick,
        "aria-label": "Previous slide",
        type: "button",
        children: /*#__PURE__*/ _jsx("svg", {
            className: "button__icon",
            width: "6px",
            height: "10px",
            "aria-hidden": "true",
            children: /*#__PURE__*/ _jsx("use", {
                xlinkHref: "#icon--chevron-right"
            })
        })
    });
};
const NextArrow = (props)=>{
    var _props_className;
    const extraClassNames = classNamesConfig().caroussel.clickableSecondary;
    return /*#__PURE__*/ _jsx("button", {
        className: `carousel__arrow carousel__arrow--next button button--secondary button--icon ${extraClassNames} ${((_props_className = props.className) === null || _props_className === void 0 ? void 0 : _props_className.includes('slick-disabled')) ? 'carousel__arrow--disabled' : ''}`,
        onClick: props.onClick,
        "aria-label": "Next slide",
        type: "button",
        children: /*#__PURE__*/ _jsx("svg", {
            className: "button__icon",
            width: "6px",
            height: "10px",
            "aria-hidden": "true",
            children: /*#__PURE__*/ _jsx("use", {
                xlinkHref: "#icon--chevron-right"
            })
        })
    });
};
export const CarouselBlockLayout = (props)=>{
    const { items, title } = props;
    const teaserprops = items.map((i, k)=>{
        var _i_video;
        return {
            key: `${k}-${i.imageUrl || i.imageUrlFallback || ((_i_video = i.video) === null || _i_video === void 0 ? void 0 : _i_video.Url) || i.title}`,
            extraClasses: 'teaser--audience block__item col-xs-12 col-sm-6 col-md-4',
            headingLevel: title && title != '' ? 'h3' : 'h2',
            title: i.title,
            linkUrl: i.linkUrl,
            intro: i.subtitle,
            label: i.label,
            imageUrl: i.imageUrl,
            imageUrlFallback: i.imageUrlFallback,
            imageUrlLarge: i.imageUrlLarge,
            imageAlt: i.imageAlt,
            video: i.video
        };
    }).toList();
    const classNames = classNamesConfig().caroussel;
    return /*#__PURE__*/ _jsx("section", {
        className: `block block--carousel ${classNames.block}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: `block__inner`,
            children: [
                title && title != '' && /*#__PURE__*/ _jsx("header", {
                    className: `block__header ${classNames.inner}`,
                    children: /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l container--xs",
                        children: title
                    })
                }),
                /*#__PURE__*/ _jsx(Slider, {
                    accessibility: true,
                    dots: true,
                    arrows: true,
                    infinite: false,
                    className: 'center',
                    centerMode: false,
                    centerPadding: '0',
                    speed: 500,
                    slidesToShow: 2.5,
                    slidesToScroll: 2,
                    swipeToSlide: true,
                    dotsClass: 'slick-dots',
                    prevArrow: /*#__PURE__*/ _jsx(PrevArrow, {}),
                    nextArrow: /*#__PURE__*/ _jsx(NextArrow, {}),
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ],
                    children: teaserprops.map((i)=>i.imageUrl && /*#__PURE__*/ _jsx("div", {
                            className: "carousel__item",
                            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                                imgClassName: "",
                                defaultImageUrl: i.imageUrlFallback || i.imageUrl,
                                cropsPerMedia: [
                                    {
                                        crops: [
                                            {
                                                url: i.imageUrl,
                                                width: 400
                                            },
                                            {
                                                url: i.imageUrlLarge || i.imageUrl,
                                                width: 800
                                            }
                                        ]
                                    }
                                ],
                                width: 660,
                                height: 371,
                                alt: i.imageAlt
                            }, "item__img-" + i.key)
                        }, "item__div-" + i.key))
                })
            ]
        })
    });
};
